/*
 * lib.tsx
 * build 生成 static/js/lib.js 共享给其他应用使用的入口文件
 * [externals]全局变量 weapp[模块名] => weappDemo, ESmodule => @weapp/demo
*/
import { configure } from 'mobx';
import React, { Suspense } from "react";
import Loading from "./components/pc/loading";
import { Provider } from 'mobx-react';
/* 导出库的样式文件，只在应用内使用不做共享的，请写在 style/index.less */
import './style/lib.less';
import * as ebcoms from "./components/ebComs";
import * as allPcStore from './store/pc';
import * as allMbStore from './store/m';
import * as commonStores from './store/common';

/* mobx 配置 */
configure({ enforceActions: 'always' });

/* 常量导出 */
export * as constants from './constants';

/*
 * 异步方式导出路由，路由中串联使用的组件，将一起被打包到路由下
 * 如非必要不要在 lib.tsx 同步引入路由串联组件，这样会导致修改重新更新 lib.js
 * 请不要对同一个文件在多处使用 import() 动态导入，会导致异步文件关系混乱
 * 打包生成路由单个 js 文件按照如下命名
 * route_${module}_${path}
*/
export const MainHeader = React.lazy(() => import(
  /* webpackChunkName: "MainHeader" */
  './components/pc/common/header')) as any;
export const MainFooter = React.lazy(() => import(
  /* webpackChunkName: "MainFooter" */
  './components/pc/common/footer')) as any;
export const LoginPool = React.lazy(() => import(
  /* webpackChunkName: "LoginPool" */
  './components/pc/loginPool/index')) as any;
export const Login = React.lazy(() => import(//登录pc
  /* webpackChunkName: "router_Login" */
  './components/pc/login/index')) as any;
export const StandardLogin = React.lazy(() => import(//登录pc
  /* webpackChunkName: "router_StandardLogin" */
  './components/pc/login/standardLogin/index')) as any;

export const PrivateLogin = React.lazy(() => import(//私有登录
  /* webpackChunkName: "router_PrivateLogin" */
  './components/pc/login/privateLogin/index')) as any;
export const I18n = React.lazy(() => import(//i18n
  /* webpackChunkName: "router_I18n" */
  './components/pc/common/i18n/index')) as any;
export const PhoneField = React.lazy(() => import(//号码段
  /* webpackChunkName: "router_PhoneField" */
  './components/pc/common/phoneField')) as any;
export const SignUp = React.lazy(() => import(//注册
  /* webpackChunkName: "router_SignUp" */
  './components/pc/signup/index')) as any;
export const SignUpForm = React.lazy(() => import(//注册
  /* webpackChunkName: "router_SignUp" */
  './components/pc/signup/signForm/index')) as any;
export const SignVerify = React.lazy(() => import(//账号验证
  /* webpackChunkName: "router_SignVerify" */
  './components/pc/signup/verify/index')) as any;
export const Teams = React.lazy(() => import(//创建团队
  /* webpackChunkName: "router_TeamsCreate" */
  './components/pc/signup/teams/index')) as any;
export const TeamsCreate = React.lazy(() => import(//创建团队
  /* webpackChunkName: "router_TeamsCreate" */
  './components/pc/signup/teams/teamsCreate/index')) as any;
export const TeamsJoin = React.lazy(() => import(//加入团队
  /* webpackChunkName: "router_TeamsJoin" */
  './components/pc/signup/teams/teamsJoin/index')) as any;

export const FindPassword = React.lazy(() => import(//忘记密码主页
  /* webpackChunkName: "router_FindPassword" */
  './components/pc/password/index')) as any;
export const FindPasswordWay = React.lazy(() => import(//召回密码的方式
  /* webpackChunkName: "router_FindPasswordWay" */
  './components/pc/password/way/index')) as any;
export const FindPasswordDo = React.lazy(() => import(//找回密码
  /* webpackChunkName: "router_FindPasswordDo" */
  './components/pc/password/do/index')) as any;
export const FindPasswordAccount = React.lazy(() => import(//忘记密码-输入账号
  /* webpackChunkName: "router_FindPasswordDo" */
  './components/pc/password/account/index')) as any;
export const FindPasswordSuccess = React.lazy(() => import(//忘记密码-完成
  /* webpackChunkName: "router_FindPasswordSuccess" */
  './components/pc/password/success/index')) as any;
export const IeIntercept = React.lazy(() => import(//ie拦截
  /* webpackChunkName: "router_IeIntercept" */
  './components/pc/ieIntercept/index')) as any;
export const InviteJoin = React.lazy(() => import(//邀请加入
  /* webpackChunkName: "router_InviteJoin" */
  './components/pc/invite/index')) as any;
export const BindAccount = React.lazy(() => import(//邀请加入
  /* webpackChunkName: "router_BindAccount" */
  './components/pc/bind/index')) as any;
export const AdminLogin = React.lazy(() => import(//邀请加入
  /* webpackChunkName: "router_AdminLogin" */
  './components/pc/adminLogin/index')) as any;
export const QysCheck = React.lazy(() => import(//邀请加入
  /* webpackChunkName: "router_QysCheck" */
  './components/pc/qyscheck/index')) as any;
export const EbBind = React.lazy(() => import(
  /* webpackChunkName: "router_EbBind" */
  './components/pc/ebBind/index')) as any;

export const MLoginPool = React.lazy(() => import(
  /* webpackChunkName: "MLoginPool" */
  './components/m/loginPool/index')) as any;

export const MLogin = React.lazy(() => import(//登录m
  /* webpackChunkName: "router_MLogin" */
  './components/m/login')) as any;
export const MStandardLogin = React.lazy(() => import(//登录m
  /* webpackChunkName: "router_MLogin" */
  './components/m/standardLogin')) as any;

export const Mi18n = React.lazy(() => import(//i18n
  /* webpackChunkName: "router_Mi18n" */
  './components/m/i18n')) as any;


export const MAccountBind = React.lazy(() => import(//h5 绑定
  /* webpackChunkName: "router_MSignUp" */
  './components/m/bind')) as any;


export const MSignUp = React.lazy(() => import(//注册
  /* webpackChunkName: "router_MSignUp" */
  './components/m/sign')) as any;

export const MSignVerify = React.lazy(() => import(//注册
  /* webpackChunkName: "router_MSignVerify" */
  './components/m/signVerify')) as any;

export const MJoinTeam = React.lazy(() => import(//加入团队
  /* webpackChunkName: "router_MJoinTeam" */
  './components/m/joinTeam')) as any;

export const MCreateTeam = React.lazy(() => import(//创建团队
  /* webpackChunkName: "router_MCreateTeam" */
  './components/m/createTeam')) as any;

export const MTeams = React.lazy(() => import(//团队页面
  /* webpackChunkName: "router_MTeams" */
  './components/m/teamsInfo')) as any;

export const MEbBind = React.lazy(() => import(
  /* webpackChunkName: "router_MEbBind" */
  './components/m/ebBind/index')) as any;

export const MFindPassword = React.lazy(() => import('./components/m/forgetPassword/index')) as any;
export const MFindPasswordSuccess = React.lazy(() => import('./components/m/forgetPassword/success/index')) as any;
export const MFindPasswordAccount = React.lazy(() => import('./components/m/forgetPassword/account/index')) as any;
export const MFindPasswordWay = React.lazy(() => import('./components/m/forgetPassword/way/index')) as any;
export const MFindPasswordDo = React.lazy(() => import('./components/m/forgetPassword/do/index')) as any;
export const MForgetPasswordStep1 = React.lazy(() => import(//忘记密码页面-first
  /* webpackChunkName: "router_MForgetPasswordStep1" */
  './components/m/forgetPassword/step1')) as any;
export const MForgetPasswordStep2 = React.lazy(() => import(//忘记密码页面-second
  /* webpackChunkName: "router_MForgetPasswordStep2" */
  './components/m/forgetPassword/step2')) as any;
export const MForgetPasswordStep3 = React.lazy(() => import(//忘记密码页面-third
  /* webpackChunkName: "router_MForgetPasswordStep3" */
  './components/m/forgetPassword/step3')) as any;
export const MThirdBind = React.lazy(() => import(//忘记密码页面-third
  /* webpackChunkName: "router_ThirdBind" */
  './components/m/thirdBind/index')) as any;
export const MInvite = React.lazy(() => import(//设置区号
  /* webpackChunkName: "router_MInvite" */
  './components/m/invite/index')) as any;
export const LayoutLogin = React.lazy(() => import(//设置区号
  /* webpackChunkName: "router_LayoutLogin" */
  './components/pc/loginpage/index')) as any;
export const Loading1 = React.lazy(() => import(//设置区号
  /* webpackChunkName: "router_CountryCode" */
  './components/pc/loading')) as any;

export const MResetPass = React.lazy(() => import(  //修改密码（管理员重置密码强制用户修改）
  /* webpackChunkName: "router_MResetPass" */
  './components/m/resetpass/index')) as any;

export { default as RouteLoginPool } from './routes/pc';
export { default as MRouteLogin } from './routes/m/login';
export { default as MRouteI18n } from './routes/m/i18n';
export { default as MRouteSignUp } from './routes/m/signup';
export { default as MRouteSignVerify } from './routes/m/signverify';
export { default as MRouteJoinTeam } from './routes/m/joinTeam';
export { default as MRouteCreateTeam } from './routes/m/createTeam';
export { default as MRouteTeams } from './routes/m/teamsInfo';
export { default as MRouteForgetPasswordStep1 } from './routes/m/forgetPasswordStep1';
export { default as MRouteForgetPasswordStep2 } from './routes/m/forgetPasswordStep2';
export { default as MRouteForgetPasswordStep3 } from './routes/m/forgetPasswordStep3';
export { default as MRouteForgetPassword } from './routes/m/forgetPassword';
export { default as MRouteThirdBind } from './routes/m/thirdBind';
export { default as MRouteInvite } from './routes/m/invite';
export { default as RouteAccountBind } from './routes/m/bind';
export { default as MRouteMEbBind } from './routes/m/ebBind';
export { default as MRouteResetPass } from './routes/m/resetpass';


export { default as RouteLogin } from './routes/pc/login';
export { default as RouteSignUp } from './routes/pc/signup';
export { default as RouteFindPassword } from './routes/pc/password';
export { default as RouteInviteJoin } from './routes/pc/invite';
export { default as RouteBindAccount } from './routes/pc/bind';
export { default as RouteAdminLogin } from './routes/pc/adminlogin';
export { default as RouteQysCheck } from './routes/pc/qyscheck';
export { default as RouteEbBind } from './routes/pc/ebBind';

// 导出ebComStyleConfigs这个对象
// 方便eb这边统一从ebComStyleConfigs对象获取组件对应的样式
export { default as ebComStyleConfigs } from './components/ebComs/login/style-config/ebComStyleConfigs';

/*
 * 同步导出业务组件，
 * 如非必要不要在 lib.tsx 同步引入路由串联组件，这样会导致修改重新更新 lib.js
*/
export { default as Loading } from './components/pc/loading';
export * from './utils/jsAPI';
/*
 * 默认导出 store 共享
 * 由于 store 需要同步注入，这样会导致修改重新更新 lib.js
*/
export * as pcStores from './store/pc';
export * as mStores from './store/m';
export * as commonStores from './store/common';
const stores = {
  ...allPcStore,
  ...allMbStore,
  ...commonStores
};
//layout登录
export function LayoutLoginCom(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`gqlp27`} fallback={<></>}>
      <LayoutLogin weId={`${props.weId || ''}_gv1nrb`} {...props} />
    </Suspense>
  </Provider>
}
//eb登录
export function EbLoginCom(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`gqlp27`} fallback={<></>}>
      <StandardLogin weId={`${props.weId || ''}_jah7gy`} source='eb' {...props} />
    </Suspense>
  </Provider>
}
// eb登录框样式demo
export function EbLoginStyleDemoCom(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`gqlp27`} fallback={<></>}>
      <StandardLogin weId={`${props.weId || ''}_jah7gy`} source='eb' styleDemo={true} {...props} />
    </Suspense>
  </Provider>
}

//eb-H5登录
export function EbMLoginCom(props: any) {
  return <Provider weId={`67vxds`} {...stores}>
    <Suspense weId={`gqlp27`} fallback={<></>}>
      <MStandardLogin weId={`${props.weId || ''}_jah7gy`} source='eb' {...props} />
    </Suspense>
  </Provider>
}
export { ebcoms }